import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";
import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  reports: "Report.Reports",
  list: "Report.ReportList",
  new: "Report.ReportNew",
  newSchedule: "Report.ReportNewSchedule",
  newSelect: "Report.ReportNewSelect",
  base: "Report.ReportBase",
  view: "Report.ReportView",
  edit: "Report.ReportEdit",
  submit: "Report.ReportSubmit",
  updateStatus: "Report.ReportUpdateStatus",
  // reportComplete: "Report.ReportComplete",
  // reportWithdraw: "Report.ReportWithdraw",
  notes: "Report.ReportNotes",
  noteEdit: "Report.ReportNoteEdit",
  noteNew: "Report.ReportNoteNew",
  documents: "Report.ReportDocuments",
  documentEdit: "Report.ReportDocumentEdit",
  documentNew: "Report.ReportDocumentNew",
  audit: "Report.ReportAudit",
};

export { names as reportRouteNames };

const reportRoutes: RouterOptions["routes"] = [
  {
    path: "/reports",
    name: names.reports,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Reports",
          lookupGroups: ["PermitType", "ReportType", "ReportFrequency", "ReportPeriod", "ReportStatus"],
        },
        component: () => import("@/views/report/ReportList.vue"),
      },
      {
        path: "new/:permitId(\\d+)?",
        component: () => import("@/views/report/ReportBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: ":reportScheduleId(\\d+)?",
            name: names.new,
            meta: { title: "New Report", isNew: true },
            component: () => import("@/views/report/ReportEdit.vue"),
          },
          {
            path: "schedule/:previousReportId(\\d+)?/:reportScheduleId(\\d+)?",
            name: names.newSchedule,
            meta: { title: "Schedule Next Report", isSchedule: true, isForm: true },
            component: () => import("@/views/report/ReportEdit.vue"),
          },
          {
            path: "select",
            name: names.newSelect,
            meta: { title: "New Report", isNew: true },
            component: () => import("@/views/report/ReportSelect.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/report/ReportBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Report View" },
            component: () => import("@/views/report/ReportView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Report Edit", isForm: true },
            component: () => import("@/views/report/ReportEdit.vue"),
          },
          {
            path: "receive",
            name: names.submit,
            meta: { title: "Submit Report", isForm: true },
            component: () => import("@/views/report/ReportSubmit.vue"),
          },
          {
            path: "updateStatus", // Also accepts a query param - approve = true
            name: names.updateStatus,
            meta: { title: "Update Report Status", isForm: true },
            component: () => import("@/views/report/ReportStatusUpdate.vue"),
          },
          // {
          //   path: "complete",
          //   name: names.reportComplete,
          //   meta: { title: "Complete Report", isForm: true },
          //   component: () => import("@/views/report/ReportComplete.vue"),
          // },
          // {
          //   path: "withdraw",
          //   name: names.reportWithdraw,
          //   meta: { title: "Withdraw Report", isForm: true },
          //   component: () => import("@/views/report/ReportWithdraw.vue"),
          // },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Report Internal Notes" },
            component: {
              render: () => <EntityNotes idField="reportId" routeNamePrefix="Report.ReportNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Report Internal Note", isForm: true },
            component: () => import("@/views/report/ReportNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Report Internal Note", isForm: true },
            component: () => import("@/views/report/ReportNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Report Documents" },
            component: {
              render: () => <EntityDocuments idField="reportId" routeNamePrefix="Report.ReportDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Report Document", isForm: true },
            component: () => import("@/views/report/ReportDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Report Document", isForm: true },
            component: () => import("@/views/report/ReportDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Report Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Report" />,
            },
          },
        ],
      },
    ],
  },
];
export default reportRoutes;
